// Relógio e limite de pausa — funções puras, sem Vue: usadas pela barra de
// pausa (useAgentPause), pelo cadastro de motivos e pelo painel supervisor
// (useSupervisorPanelFormat, que é sem dependência de framework).
const pad = n => String(n).padStart(2, '0');

// Cronômetro da pausa: "04:09", "1:05:00".
export const formatPauseClock = totalSeconds => {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return h ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

// Limite legível: "1 min", "15 min", "1h05".
export const formatPauseLimit = totalSeconds => {
  const minutes = Math.round(totalSeconds / 60);
  if (minutes < 60) return `${minutes} min`;
  return `${Math.floor(minutes / 60)}h${pad(minutes % 60)}`;
};
